import { ButtonProps } from "../../../../types"
import Button from "../button"

export const AltBtn = ({ children, className = "", ...rest }: ButtonProps) => (
  <Button
    {...rest}
    className={`${className} border-transparent text-white bg-violet-500 hover:bg-violet-600 disabled:bg-neutral-400 focus:ring-violet-400 focus:ring-1`}
  >
    {children}
  </Button>
)

export const AltOutlineBtn = ({
  children,
  className = "",
  ...rest
}: ButtonProps) => (
  <Button
    {...rest}
    className={`${className} font-normal border-violet-500 text-violet-500 bg-transparent hover:bg-violet-500 hover:text-white focus:border-violet-600 focus:ring-1 focus:ring-violet-600 disabled:bg-neutral-400`}
  >
    {children}
  </Button>
)
